import React from 'react';

type Props = {
  alertMessage: string,
  alertClass?: string,
  dataId?: string,
};

function AlertInfo(props: Props) {
  const { alertMessage, dataId, alertClass } = props;
  return (
    <div className={`alert u__text--alternate u--paddingNone ${alertClass}`}>
      <span className="mw-icon-info u--marginXsmall-right" />
      <p className="alert__message" data-automation-id={dataId && dataId}>
        {alertMessage}
      </p>
    </div>
  );
}

AlertInfo.defaultProps = {
  dataId: null,
  alertClass: '',
};

export default AlertInfo;
